<template>
  <div class="pw-title">
    <div v-if="title || actionText" class="pw-title__title" :class="`pw-title__title--${color}`">
      <h2 v-html="title"></h2>
      <div class="pw-title__actions" v-if="actionText && showAction">
        <button class="pw-title__action" @click="$emit('clickAction')">
          <i class="mdi" :class="`mdi-${icon}`"></i>
          {{ actionText }}
        </button>
      </div>
    </div>
    <p v-if="description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    title: String,
    description: String,
    actionText: String,
    color: {
      type: String,
      default: 'basic',
    },
    showAction: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: 'pencil',
    },
  },
};
</script>

<style lang="scss" scoped>
.pw-title {
  margin-bottom: 16px;
  &__title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    &--primary {
      h2 {
        color: #6ae1c8 !important;
      }
    }
    &--secondary {
      h2 {
        color: #5b89f2 !important;
      }
    }
    &--secondary {
      h2 {
        color: #5b89f2 !important;
      }
    }
  }
  &__actions {
    padding-right: 10px;
  }
  &__action {
    background-color: transparent;
    color: #5185fe;
    border: 0;
    margin-left: 10px;
    cursor: pointer;
    outline: none;
  }
  h2 {
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    margin: 0;
  }
  p {
    color: #333333;
    line-height: 1.38;
    margin: 0;
  }
}
</style>
